import BranchDto from '@/models/Branches/BranchDto';
import LocationDto from '@/models/Locations/LocationDto';
import DepartmentDto from '@/models/Departments/DepartmentDto';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel';
import AgencyUserDto from '../AgencyUsers/AgencyUserDto';
import ContactDto from '../Contacts/ContactDto';
import ContactLocationDto from '../ContactLocations/ContactLocationDto';

export default class NewBookingViewModel {
    id = '';
    dates: string[] = []
    branch: BranchDto = new BranchDto()
    location: LocationDto = new LocationDto();
    owner: AgencyUserDto = new AgencyUserDto();
    contactLocation: ContactLocationDto;
    department: DepartmentDto = new DepartmentDto();
    isTest = false;
    testEmailAddresses = '';
    purchaseOrderNumber = '';
    instructions = '';
    roles: BookingRoleViewModel[] = [];
    currentStep = 1;
}